package com.shadowings.gero.domain.model

import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@Serializable
data class TextTranslationContent @OptIn(ExperimentalUuidApi::class) constructor(
    val hieroglyphs: String,
    val correctPhrase: String,
    val transliteration: String? = null,
    val soggettiCount: Int? = null,
    val oggettiCount: Int? = null,
    override val id: String = Uuid.random().toHexDashString()
) : IQuizContent, ICountableQuiz
